<style>
html,
body,
#app {
  background: #f7f9fc;
}

#app {
  font-family: Avenir, Helvetica, Arial, sans-serif;
  -webkit-font-smoothing: antialiased;
  -moz-osx-font-smoothing: grayscale;
  color: #2c3e50;
  position: relative;
  overflow: auto;
}

#nav {
  width: 100%;
  /*margin-bottom: 100px;*/
  /*position: absolute;*/
  /*z-index: 10;*/
}

#body {
  /*margin-top: calc(100px + 20px);*/
  margin-top: 20px;
}

#footer {
  text-align: center;
}

th {
  white-space: nowrap;
}

.pre-wrap {
  white-space: pre-wrap;
}

/* sh365用のdefault色をbootstrap-vueでクラスとして使えるように */
.btn.btn-default {
  background-color: #33537e;
  color: #fff;
}
.btn.btn-default:hover {
  color: #fff;
  opacity: 0.9;
}
.default-table .page-item .page-link {
  color:#33537e;
}
.default-table .page-item.active .page-link {
  background-color: #33537e;
  border-color: #33537e;
}
</style>

<!-- 共通のヘッダ・フッタ -->
<template>
  <div id="app">
    <div id="nav">
      <div v-if="this.isLoggedIn">
        <!-- ログインしていたとしても、ログイン画面とポートフォリオの閲覧時はヘッダーを表示しない -->
        <template v-if="this.$route.name && this.$route.name !== 'PortfolioTop' && !this.$route.name.includes('Login')">
          <SHNavbar
            :isAdmin="isAdmin"
            :loginUserName="loginUserName"
            :logout="logout"
            :pfIcoDataURL="pfIcoDataURL"
          ></SHNavbar>
        </template>
      </div>
    </div>
    <div id="body" class="mx-sm-5 pb-sm-5 mx-1 pb-1">
      <router-view />
    </div>
    <!--
    <div id="footer" class="fixed-bottom mx-5 bg-white">
      <hr class="my-2">
      <small>©︎2021 NICT</small>
    </div>
    -->
  </div>
</template>

<script>
import { mapState } from 'vuex'
import SHNavbar from '@/components/navbar/SHNavbar.vue'

export default {
  name: 'App',
  components: {
    SHNavbar
  },
  computed: {
    ...mapState({
      isLoggedIn: (state) => state.auth.isLoggedIn,
      loginUserName: (state) => state.auth.loginUserName,
      pfIcoDataURL: (state) => state.user.pfIcoDataURL
    }),
    isAdmin: function () {
      if (this.$route.path.indexOf('admin') >= 0) {
        return true
      }
      return false
    }
  },
  methods: {
    logout() {
      this.$store.dispatch('auth/logout')
    }
  }
}
</script>
